
import styled from "styled-components"
import { getAllPastAiNewModelMessages } from "../../features/aiControl/aiControlSlice"
import { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector} from "react-redux"
import moment from "moment"
import Pagination from "../shared/Pagination"
import AiMobileNewModelPastMessageItemContainer from "./AiMobileNewModelPastMessageItemContainer"

const Container = styled.div`

.message-container{
        display: flex;
        flex-direction: column;
        gap: 20px;

        .messages-grp{
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 10px;

          .messages-grp-top-container{
            width: 100%;

            h4{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-lg);
              border-bottom: 2px solid ${({theme}) => theme.mainTextColor};
            }
          }

          .messages-grp-date-grp{
            display: flex;
            flex-direction: column;
            gap: 15px;
          }
        }

    }
    
`

const MobilePastAiChatNewModel = () => {

    const dispatch = useDispatch()

    const topRef = useRef()

    const {allPastAiMessagesCountNewModel, allPastAiMessagesNewModel} = useSelector(state => state.aiControl)

    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 50;

    useEffect(() => {
     if (topRef.current) {
        // Elemanın viewport'taki mutlak konumunu bulun
        const rect = topRef.current.getBoundingClientRect();
        // Sayfanın en üstünden elemana kadar olan mesafe (px)
        const elemTop = rect.top + window.pageYOffset;
        // 200px yukarıdan başlatmak için 200 çıkarıyoruz
        const scrollToPos = elemTop - 300;

        window.scrollTo({
            top: scrollToPos,
            behavior: 'smooth'
        });
        }
    },[currentPage])

    const totalPages = Math.ceil(allPastAiMessagesCountNewModel / itemsPerPage);

    useEffect(()=> {
        dispatch(getAllPastAiNewModelMessages({page:currentPage}))
      },[currentPage])

  return (
    <Container ref={topRef}>
        <div className="message-container" >
            {
              allPastAiMessagesNewModel.map((item) => (
                <div className="messages-grp">
                  <div className="messages-grp-top-container">
                    <h4>{moment(item.createdAt).format("L")}</h4>
                  </div>
                  <div className="messages-grp-date-grp">
                    {
                      item.data.map(innerItem => (
                        <AiMobileNewModelPastMessageItemContainer item={innerItem}/>
                      ))
                    }
                  </div>

                </div>
              ))
            }
          </div>
        
          {
            (allPastAiMessagesNewModel || allPastAiMessagesNewModel?.length > 0) && (
              <Pagination
                totalPages={totalPages}
                handleClick={setCurrentPage}
                currentPage={currentPage}
              />
            )
            }
    </Container>
  )
}

export default MobilePastAiChatNewModel